function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 85 85)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 85 85)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-45 85 85)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "alt-color",
  fill: "none",
  stroke: "#61af5f",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 6,
  d: "M76.024 107.615a24.6 24.6 0 0 1-14.092-14.743"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#feffff",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 6,
  d: "M108.48 92.295a24.597 24.597 0 0 1-14.284 15.32"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "alt-color",
  fill: "none",
  stroke: "#61af5f",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 6,
  d: "M93.16 61.647a24.594 24.594 0 0 1 15.248 15.483"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#feffff",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 6,
  d: "M61.82 77.106a24.593 24.593 0 0 1 15.24-15.46"
}))))));

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.fdc608bd.svg";
export { ForwardRef as ReactComponent };